import { render, staticRenderFns } from "./IconDocumentList.vue?vue&type=template&id=6ca448a3"
import script from "./IconDocumentList.vue?vue&type=script&lang=js"
export * from "./IconDocumentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports